import { useEffect, useState } from "react"
import { useSnackbar } from "../../../context/snackbar"

function AddToListModal({ product }) {
  const API = `${process.env.REACT_APP_API_URL}/api/lists`

  const { showSnackbar } = useSnackbar()

  const [lists, setLists] = useState([])
  const [refresh, setRefresh] = useState(true)

  /* =========================
     FETCH LISTS
  ========================= */
  useEffect(() => {
    const fetchLists = async () => {
      try {
        const res = await fetch(API, {
          credentials: "include",
        })

        const data = await res.json()

        if (res.ok) {
          setLists(Array.isArray(data) ? data : [])
        }
      } catch (err) {
        console.error(err)
      }
    }

    if (refresh) {
      fetchLists()
      setRefresh(false)
    }
  }, [refresh])

  /* =========================
     ADD TO LIST
  ========================= */
  const addToList = async (listId) => {
    try {
      const res = await fetch(`${API}/${listId}/items`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          productId: product._id,
        }),
      })

      const data = await res.json()

      if (!res.ok) {
        showSnackbar(data.message || "Failed to add", "error")
        return
      }

      showSnackbar("Added to list", "success")
      setRefresh(true)
    } catch (err) {
      console.error(err)
      showSnackbar("Something went wrong", "error")
    }
  }

  return (
    <div
      className="modal fade"
      id="addToListModal"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          {/* HEADER */}
          <div className="modal-header">
            <h5 className="modal-title">Add to List</h5>
            <button className="btn-close" data-bs-dismiss="modal" />
          </div>

          {/* BODY */}
          <div className="modal-body">
            {lists.length === 0 && (
              <p className="text-muted">No lists available</p>
            )}

            {lists.map((l) => (
              <button
                key={l._id}
                className="btn btn-outline-dark w-100 mb-2"
                onClick={() => addToList(l._id)}
                data-bs-dismiss="modal"
              >
                {l.name}
              </button>
            ))}
          </div>

          {/* FOOTER */}
          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddToListModal
